// import React, { useState, useEffect } from 'react';
// import { 
//   FaStar, 
//   FaRegStar,
//   FaUser,
//   FaEnvelope,
//   FaBuilding,
//   FaComment,
//   FaPaperPlane,
//   FaCheckCircle,
//   FaQuoteLeft,
//   FaGraduationCap,
//   FaChalkboardTeacher,
//   FaUserTie,
//   FaFilter
// } from 'react-icons/fa';

// const FeedbackSystem = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     userType: '',
//     course: '',
//     rating: 0,
//     comment: ''
//   });

//   const [hoverRating, setHoverRating] = useState(0);
//   const [feedbacks, setFeedbacks] = useState([]);
//   const [filteredFeedbacks, setFilteredFeedbacks] = useState([]);
//   const [showSuccess, setShowSuccess] = useState(false);
//   const [filter, setFilter] = useState('all');
//   const [loading, setLoading] = useState(true);

//   const courses = [
//     'Web Development',
//     'Data Science',
//     'Machine Learning',
//     'Mobile App Development',
//     'Digital Marketing',
//     'Graphic Design',
//     'Cloud Computing',
//     'Cyber Security',
//     'Business Analytics',
//     'Other'
//   ];

//   const userTypes = [
//     { value: 'student', label: 'Student', icon: <FaGraduationCap /> },
//     { value: 'parent', label: 'Parent/Guardian', icon: <FaUser /> },
//     { value: 'teacher', label: 'Teacher', icon: <FaChalkboardTeacher /> },
//     { value: 'management', label: 'College Management', icon: <FaUserTie /> },
//     { value: 'visitor', label: 'Visitor', icon: <FaUser /> }
//   ];

//   // Load feedbacks from storage on mount
//   useEffect(() => {
//     loadFeedbacks();
//   }, []);

//   // Filter feedbacks when filter changes
//   useEffect(() => {
//     filterFeedbacks();
//   }, [filter, feedbacks]);

//   const loadFeedbacks = async () => {
//     try {
//       const result = await window.storage.list('feedback:');
//       if (result && result.keys) {
//         const allFeedbacks = await Promise.all(
//           result.keys.map(async (key) => {
//             const data = await window.storage.get(key);
//             return data ? JSON.parse(data.value) : null;
//           })
//         );
//         const validFeedbacks = allFeedbacks.filter(f => f !== null);
//         setFeedbacks(validFeedbacks.sort((a, b) => b.timestamp - a.timestamp));
//       }
//     } catch (error) {
//       console.log('No existing feedbacks found');
//       setFeedbacks([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const filterFeedbacks = () => {
//     if (filter === 'all') {
//       setFilteredFeedbacks(feedbacks);
//     } else {
//       setFilteredFeedbacks(feedbacks.filter(f => f.userType === filter));
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleRatingClick = (rating) => {
//     setFormData(prev => ({
//       ...prev,
//       rating
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!formData.name || !formData.email || !formData.userType || !formData.rating || !formData.comment) {
//       alert('Please fill in all required fields');
//       return;
//     }

//     const newFeedback = {
//       ...formData,
//       id: `feedback_${Date.now()}`,
//       timestamp: Date.now(),
//       date: new Date().toLocaleDateString('en-IN')
//     };

//     try {
//       // Save to storage
//       await window.storage.set(`feedback:${newFeedback.id}`, JSON.stringify(newFeedback));
      
//       // Update local state
//       setFeedbacks(prev => [newFeedback, ...prev]);
      
//       // Reset form
//       setFormData({
//         name: '',
//         email: '',
//         userType: '',
//         course: '',
//         rating: 0,
//         comment: ''
//       });

//       // Show success message
//       setShowSuccess(true);
//       setTimeout(() => setShowSuccess(false), 5000);

//       // Scroll to feedbacks section
//       setTimeout(() => {
//         document.getElementById('feedbacks-section')?.scrollIntoView({ behavior: 'smooth' });
//       }, 500);
//     } catch (error) {
//       console.error('Error saving feedback:', error);
//       alert('Failed to submit feedback. Please try again.');
//     }
//   };

//   const getAverageRating = () => {
//     if (feedbacks.length === 0) return 0;
//     const sum = feedbacks.reduce((acc, f) => acc + f.rating, 0);
//     return (sum / feedbacks.length).toFixed(1);
//   };

//   const getRatingDistribution = () => {
//     const dist = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
//     feedbacks.forEach(f => {
//       dist[f.rating] = (dist[f.rating] || 0) + 1;
//     });
//     return dist;
//   };

//   const renderStars = (rating, clickable = false, size = '1.5rem') => {
//     return (
//       <div className="d-inline-flex">
//         {[1, 2, 3, 4, 5].map((star) => (
//           <span
//             key={star}
//             onClick={() => clickable && handleRatingClick(star)}
//             onMouseEnter={() => clickable && setHoverRating(star)}
//             onMouseLeave={() => clickable && setHoverRating(0)}
//             style={{
//               cursor: clickable ? 'pointer' : 'default',
//               color: star <= (hoverRating || rating) ? '#ffc107' : '#e4e5e9',
//               fontSize: size,
//               marginRight: '0.25rem'
//             }}
//           >
//             {star <= (hoverRating || rating) ? <FaStar /> : <FaRegStar />}
//           </span>
//         ))}
//       </div>
//     );
//   };

//   const getUserTypeLabel = (type) => {
//     const userType = userTypes.find(ut => ut.value === type);
//     return userType ? userType.label : type;
//   };

//   const getUserTypeIcon = (type) => {
//     const userType = userTypes.find(ut => ut.value === type);
//     return userType ? userType.icon : <FaUser />;
//   };

//   return (
//     <div className="min-vh-100" style={{ backgroundColor: '#f8f9fa' }}>
//       {/* Header */}
//       <div className="bg-primary text-white py-5 my-5">
//         <div className="container">
//           <div className="text-center">
//             <FaComment style={{ fontSize: '3rem' }} className="mb-3" />
//             <h1 className="display-4 fw-bold mb-3">Share Your Feedback</h1>
//             <p className="lead">Help us improve Olewin Academy with your valuable feedback</p>
//           </div>
//         </div>
//       </div>

//       {/* Success Message */}
//       {showSuccess && (
//         <div className="container mt-4">
//           <div className="alert alert-success alert-dismissible fade show" role="alert">
//             <FaCheckCircle className="me-2" />
//             <strong>Thank you!</strong> Your feedback has been submitted successfully.
//             <button type="button" className="btn-close" onClick={() => setShowSuccess(false)}></button>
//           </div>
//         </div>
//       )}

//       {/* Feedback Form */}
//       <div className="container py-5">
//         <div className="row justify-content-center">
//           <div className="col-lg-8">
//             <div className="card border-0 shadow-sm">
//               <div className="card-body p-4 p-md-5">
//                 <h2 className="h3 mb-4 text-center">Submit Your Feedback</h2>
                
//                 <form onSubmit={handleSubmit}>
//                   <div className="row g-3">
//                     {/* Name */}
//                     <div className="col-md-6">
//                       <label className="form-label fw-semibold">
//                         <FaUser className="me-2" />
//                         Full Name <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         name="name"
//                         value={formData.name}
//                         onChange={handleInputChange}
//                         placeholder="Enter your name"
//                         required
//                       />
//                     </div>

//                     {/* Email */}
//                     <div className="col-md-6">
//                       <label className="form-label fw-semibold">
//                         <FaEnvelope className="me-2" />
//                         Email Address <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         type="email"
//                         className="form-control"
//                         name="email"
//                         value={formData.email}
//                         onChange={handleInputChange}
//                         placeholder="your.email@example.com"
//                         required
//                       />
//                     </div>

//                     {/* User Type */}
//                     <div className="col-md-6">
//                       <label className="form-label fw-semibold">
//                         <FaBuilding className="me-2" />
//                         I am a <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-select"
//                         name="userType"
//                         value={formData.userType}
//                         onChange={handleInputChange}
//                         required
//                       >
//                         <option value="">Select your role</option>
//                         {userTypes.map(type => (
//                           <option key={type.value} value={type.value}>{type.label}</option>
//                         ))}
//                       </select>
//                     </div>

//                     {/* Course */}
//                     <div className="col-md-6">
//                       <label className="form-label fw-semibold">
//                         <FaGraduationCap className="me-2" />
//                         Course/Interest Area
//                       </label>
//                       <select
//                         className="form-select"
//                         name="course"
//                         value={formData.course}
//                         onChange={handleInputChange}
//                       >
//                         <option value="">Select a course (optional)</option>
//                         {courses.map(course => (
//                           <option key={course} value={course}>{course}</option>
//                         ))}
//                       </select>
//                     </div>

//                     {/* Rating */}
//                     <div className="col-12">
//                       <label className="form-label fw-semibold">
//                         <FaStar className="me-2" />
//                         Overall Rating <span className="text-danger">*</span>
//                       </label>
//                       <div className="p-3 bg-light rounded text-center">
//                         {renderStars(formData.rating, true, '2rem')}
//                         <p className="mt-2 mb-0 text-muted">
//                           {formData.rating === 0 && 'Click to rate'}
//                           {formData.rating === 1 && 'Poor'}
//                           {formData.rating === 2 && 'Fair'}
//                           {formData.rating === 3 && 'Good'}
//                           {formData.rating === 4 && 'Very Good'}
//                           {formData.rating === 5 && 'Excellent'}
//                         </p>
//                       </div>
//                     </div>

//                     {/* Comment */}
//                     <div className="col-12">
//                       <label className="form-label fw-semibold">
//                         <FaComment className="me-2" />
//                         Your Feedback <span className="text-danger">*</span>
//                       </label>
//                       <textarea
//                         className="form-control"
//                         name="comment"
//                         value={formData.comment}
//                         onChange={handleInputChange}
//                         rows="5"
//                         placeholder="Share your experience with Olewin Academy..."
//                         required
//                       ></textarea>
//                       <div className="form-text">Minimum 10 characters</div>
//                     </div>

//                     {/* Submit Button */}
//                     <div className="col-12">
//                       <button type="submit" className="btn btn-primary btn-lg w-100">
//                         <FaPaperPlane className="me-2" />
//                         Submit Feedback
//                       </button>
//                     </div>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Statistics Section */}
//       {feedbacks.length > 0 && (
//         <div className="bg-white py-5">
//           <div className="container">
//             <div className="row text-center g-4">
//               <div className="col-md-3 col-6">
//                 <div className="p-3">
//                   <h3 className="display-4 text-primary mb-2">{feedbacks.length}</h3>
//                   <p className="text-muted mb-0">Total Reviews</p>
//                 </div>
//               </div>
//               <div className="col-md-3 col-6">
//                 <div className="p-3">
//                   <h3 className="display-4 text-warning mb-2">{getAverageRating()}</h3>
//                   <p className="text-muted mb-0">Average Rating</p>
//                   {renderStars(Math.round(getAverageRating()))}
//                 </div>
//               </div>
//               <div className="col-md-3 col-6">
//                 <div className="p-3">
//                   <h3 className="display-4 text-success mb-2">
//                     {feedbacks.filter(f => f.rating >= 4).length}
//                   </h3>
//                   <p className="text-muted mb-0">Happy Customers</p>
//                 </div>
//               </div>
//               <div className="col-md-3 col-6">
//                 <div className="p-3">
//                   <h3 className="display-4 text-info mb-2">
//                     {new Set(feedbacks.map(f => f.course).filter(Boolean)).size}
//                   </h3>
//                   <p className="text-muted mb-0">Courses Reviewed</p>
//                 </div>
//               </div>
//             </div>

//             {/* Rating Distribution */}
//             <div className="row mt-4">
//               <div className="col-lg-8 mx-auto">
//                 <div className="card border-0 shadow-sm">
//                   <div className="card-body">
//                     <h4 className="h5 mb-4">Rating Distribution</h4>
//                     {Object.entries(getRatingDistribution()).reverse().map(([rating, count]) => (
//                       <div key={rating} className="mb-3">
//                         <div className="d-flex align-items-center">
//                           <span className="me-2" style={{ minWidth: '80px' }}>
//                             {rating} <FaStar className="text-warning" />
//                           </span>
//                           <div className="progress flex-grow-1" style={{ height: '20px' }}>
//                             <div
//                               className="progress-bar bg-warning"
//                               role="progressbar"
//                               style={{ width: `${feedbacks.length > 0 ? (count / feedbacks.length) * 100 : 0}%` }}
//                             >
//                               {count > 0 && count}
//                             </div>
//                           </div>
//                           <span className="ms-2 text-muted" style={{ minWidth: '60px', textAlign: 'right' }}>
//                             {feedbacks.length > 0 ? Math.round((count / feedbacks.length) * 100) : 0}%
//                           </span>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Feedbacks Display Section */}
//       <div id="feedbacks-section" className="container py-5">
//         <div className="text-center mb-5">
//           <h2 className="display-5 fw-bold mb-3">What People Say About Us</h2>
//           <p className="lead text-muted">Real feedback from our students, parents, and partners</p>
//         </div>

//         {/* Filter Buttons */}
//         {feedbacks.length > 0 && (
//           <div className="d-flex justify-content-center flex-wrap gap-2 mb-4">
//             <button
//               className={`btn ${filter === 'all' ? 'btn-primary' : 'btn-outline-primary'}`}
//               onClick={() => setFilter('all')}
//             >
//               <FaFilter className="me-2" />
//               All ({feedbacks.length})
//             </button>
//             {userTypes.map(type => {
//               const count = feedbacks.filter(f => f.userType === type.value).length;
//               return count > 0 && (
//                 <button
//                   key={type.value}
//                   className={`btn ${filter === type.value ? 'btn-primary' : 'btn-outline-primary'}`}
//                   onClick={() => setFilter(type.value)}
//                 >
//                   {type.icon} <span className="ms-2">{type.label} ({count})</span>
//                 </button>
//               );
//             })}
//           </div>
//         )}

//         {/* Feedbacks Grid */}
//         {loading ? (
//           <div className="text-center py-5">
//             <div className="spinner-border text-primary" role="status">
//               <span className="visually-hidden">Loading...</span>
//             </div>
//           </div>
//         ) : filteredFeedbacks.length === 0 ? (
//           <div className="text-center py-5">
//             <FaComment style={{ fontSize: '4rem', opacity: 0.2 }} />
//             <h3 className="h5 mt-3 text-muted">
//               {feedbacks.length === 0 ? 'No feedback yet. Be the first to share!' : 'No feedback found for this filter.'}
//             </h3>
//           </div>
//         ) : (
//           <div className="row g-4">
//             {filteredFeedbacks.map((feedback) => (
//               <div key={feedback.id} className="col-lg-4 col-md-6">
//                 <div className="card border-0 shadow-sm h-100">
//                   <div className="card-body">
//                     <div className="d-flex justify-content-between align-items-start mb-3">
//                       <div className="d-flex align-items-center">
//                         <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center" 
//                              style={{ width: '50px', height: '50px', fontSize: '1.5rem' }}>
//                           {getUserTypeIcon(feedback.userType)}
//                         </div>
//                         <div className="ms-3">
//                           <h5 className="mb-0">{feedback.name}</h5>
//                           <small className="text-muted">{getUserTypeLabel(feedback.userType)}</small>
//                         </div>
//                       </div>
//                       {renderStars(feedback.rating, false, '1rem')}
//                     </div>
                    
//                     {feedback.course && (
//                       <div className="mb-2">
//                         <span className="badge bg-light text-dark">
//                           <FaGraduationCap className="me-1" />
//                           {feedback.course}
//                         </span>
//                       </div>
//                     )}
                    
//                     <div className="position-relative">
//                       <FaQuoteLeft className="text-primary opacity-25 position-absolute" 
//                                    style={{ fontSize: '2rem', top: '-10px', left: '-5px' }} />
//                       <p className="mb-3 mt-3 fst-italic" style={{ paddingLeft: '30px' }}>
//                         {feedback.comment}
//                       </p>
//                     </div>
                    
//                     <div className="text-end">
//                       <small className="text-muted">{feedback.date}</small>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>

//       {/* Call to Action */}
//       <div className="bg-primary text-white py-5">
//         <div className="container text-center">
//           <h2 className="h3 mb-3">Haven't shared your experience yet?</h2>
//           <p className="lead mb-4">Your feedback helps us serve you better</p>
//           <button 
//             className="btn btn-light btn-lg"
//             onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
//           >
//             <FaPaperPlane className="me-2" />
//             Share Your Feedback
//           </button>
//         </div>
//       </div>

//       {/* Bootstrap CSS */}
//       <link
//         href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
//         rel="stylesheet"
//       />
//     </div>
//   );
// };

// export default FeedbackSystem;
 //https://script.google.com/macros/s/AKfycbxvrmkxauW1bO9h3PRhy-oF4tIXMMdyh2uwYLHPaWC3MCzqeK0B-yctoZ35oRnHY8Z2/exec

// 

import React, { useState, useEffect } from 'react';
import { 
  FaStar, 
  FaRegStar,
  FaUser,
  FaEnvelope,
  FaBuilding,
  FaComment,
  FaPaperPlane,
  FaCheckCircle,
  FaQuoteLeft,
  FaGraduationCap,
  FaChalkboardTeacher,
  FaUserTie,
  FaFilter,
  FaExclamationTriangle,
  FaCommentDots,
  FaQuoteRight,
  FaGooglePlus
} from 'react-icons/fa';
import logo from '../images/channelicon2.png';
import { Link } from 'react-router-dom';

const FeedbackSystem = () => {
  const GOOGLE_SCRIPT_URL = ' https://script.google.com/macros/s/AKfycbxvrmkxauW1bO9h3PRhy-oF4tIXMMdyh2uwYLHPaWC3MCzqeK0B-yctoZ35oRnHY8Z2/exec';

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    userType: '',
    course: '',
    rating: 0,
    comment: ''
  });

const [feedbacks, setFeedbacks] = useState([
// data will be displayed from apis

])

  const [hoverRating, setHoverRating] = useState(0);
  const [filteredFeedbacks, setFilteredFeedbacks] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

 const courses = [
  // AI, Data & Machine Learning
  'Artificial Intelligence & Deep Learning',
  'Machine Learning',
  'Data Science',
  'Data Analytics',
  'Business Analytics',
  'Natural Language Processing (NLP)',
  'Computer Vision',
  'AI for Geosciences',
  'Quantum Computing & AI Integration',
  'AI in Energy and Climate Modeling',

  // Software Development & Programming
  'Web Development (Full Stack – MERN / MEAN)',
  'Mobile App Development (Flutter / React Native)',
  'Python Programming',
  'Java Programming',
  'C/C++ Programming',
  'Software Engineering (SDE Pathway)',
  'Backend Development (Node.js, Django, FastAPI)',
  'Frontend Development (React, Angular, Vue)',
  'DevOps & CI/CD Automation',
  'Cloud-Native Application Development',

  // Cloud, Networking & Cybersecurity
  'Cloud Computing (AWS, Azure, GCP)',
  'Cloud Architecture & Security',
  'Cyber Security & Ethical Hacking',
  'Network Administration',
  'DevSecOps',
  'Cloud Storage & Virtualization',
  'IoT (Internet of Things) with Cloud Integration',

  // Geosciences, Energy & Environment
  'Geology & Geophysics',
  'Remote Sensing & GIS',
  'Meteorology & Climatology',
  'Energy Resources & Sustainability',
  'Renewable Energy Systems (Solar, Wind, Hydro)',
  'Petroleum Geoscience',
  'Environmental Management & Policy',
  'Earth Observation & Satellite Data Analytics',
  'Smart Grid & Energy AI Systems',

  // Business, Management & Finance
  'Digital Marketing',
  'Business Intelligence (Power BI, Tableau)',
  'Entrepreneurship & Startup Development',
  'Management Consulting & Strategy',
  'Financial Analytics',
  'Supply Chain & Logistics Management',
  'Human Resource Management (HR Analytics)',
  'Product Management',
  'E-Commerce & Brand Strategy',

  // Design, Multimedia & UI/UX
  'Graphic Design (Photoshop, Illustrator)',
  'UI/UX Design',
  'Video Editing & VFX',
  'Animation & Motion Graphics',
  'Creative Media Production (Film & Studio Tech)',

  // Advanced & Specialized
  'Blockchain Development',
  'AR/VR Application Development',
  'Quantum Programming with Qiskit',
  'Robotic Process Automation (RPA)',
  'Embedded Systems & Robotics',
  'SAP (SD, MM, FI, HCM, ABAP)',
  'Industrial AI & Predictive Maintenance',
  'Smart Cities & IoT Solutions',
  'Environmental AI & Climate Tech',
  'Research & Innovation Program (MSc/PhD Level)',

  // Foundational & School Programs
  'Coding for Kids (Python, Scratch, C++)',
  'Robotics for School Students',
  'AI & Machine Learning for School Students',
  'Space Science & Astronomy Fundamentals',
  'Quantum Concepts for Young Innovators',
  'Mathematics through Programming',
  'Junior Scientist Program (STEM Integration)',

  // General placeholder
  'Other'
];


  const userTypes = [
    { value: 'student', label: 'Student', icon: <FaGraduationCap /> },
    { value: 'parent', label: 'Parent/Guardian', icon: <FaUser /> },
    { value: 'teacher', label: 'Teacher', icon: <FaChalkboardTeacher /> },
    { value: 'management', label: 'College Management', icon: <FaUserTie /> },
    { value: 'working', label: 'Working Professional', icon: <FaUserTie /> },
    { value: 'Researcher', label: 'Research Scientist', icon: <FaUserTie /> },
    { value: 'visitor', label: 'Visitor', icon: <FaUser /> }
  ];

  useEffect(() => {
    loadFeedbacks();
  }, []);

  useEffect(() => {
    filterFeedbacks();
  }, [filter, feedbacks]);

  const loadFeedbacks = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${GOOGLE_SCRIPT_URL}?action=getFeedbacks`);
      const data = await response.json();
      
      if (data.success) {
        const sortedFeedbacks = data.feedbacks.sort((a, b) => b.timestamp - a.timestamp);
        setFeedbacks(sortedFeedbacks);
      } else {
        console.error('Error loading feedbacks:', data.error);
        setFeedbacks([]);
      }
    } catch (error) {
      console.error('Error fetching feedbacks:', error);
      setErrorMessage('Unable to load feedbacks. Please check your Google Script URL.');
      setFeedbacks([]);
    } finally {
      setLoading(false);
    }
  };

  const filterFeedbacks = () => {
    if (filter === 'all') {
      setFilteredFeedbacks(feedbacks);
    } else {
      setFilteredFeedbacks(feedbacks.filter(f => f.userType === filter));
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleRatingClick = (rating) => {
    setFormData(prev => ({ ...prev, rating }));
  };

  const handleSubmit = async () => {
    if (!formData.name || !formData.email || !formData.userType || !formData.rating || !formData.comment) {
      alert('Please fill in all required fields');
      return;
    }

    if (formData.comment.length < 10) {
      alert('Please provide a comment with at least 10 characters');
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      alert('Please enter a valid email address');
      return;
    }

    setSubmitting(true);
    setShowError(false);

    try {
      const feedbackData = {
        action: 'addFeedback',
        name: formData.name,
        email: formData.email,
        userType: formData.userType,
        course: formData.course || 'Not specified',
        rating: formData.rating,
        comment: formData.comment,
        timestamp: Date.now(),
        date: new Date().toLocaleDateString('en-IN')
      };

      const response = await fetch(GOOGLE_SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(feedbackData)
      });

      // Since we're using no-cors, we can't read the response
      // We'll assume success and reload feedbacks
      setFormData({ name: '', email: '', userType: '', course: '', rating: 0, comment: '' });
      setShowSuccess(true);
      
      // Reload feedbacks after a short delay
      setTimeout(() => {
        loadFeedbacks();
      }, 2000);

      setTimeout(() => setShowSuccess(false), 5000);
      setTimeout(() => {
        document.getElementById('feedbacks-section')?.scrollIntoView({ behavior: 'smooth' });
      }, 500);
    } catch (error) {
      console.error('Error submitting feedback:', error);
      setErrorMessage('Failed to submit feedback. Please try again.');
      setShowError(true);
      setTimeout(() => setShowError(false), 5000);
    } finally {
      setSubmitting(false);
    }
  };

  const getAverageRating = () => {
    if (feedbacks.length === 0) return 0;
    const sum = feedbacks.reduce((acc, f) => acc + f.rating, 0);
    return (sum / feedbacks.length).toFixed(1);
  };

  const getRatingDistribution = () => {
    const dist = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
    feedbacks.forEach(f => { dist[f.rating] = (dist[f.rating] || 0) + 1; });
    return dist;
  };

  const renderStars = (rating, clickable = false, size = '1.5rem') => {
    return (
      <div className="d-inline-flex">
        {[1, 2, 3, 4, 5].map((star) => (
          <span
            key={star}
            onClick={() => clickable && handleRatingClick(star)}
            onMouseEnter={() => clickable && setHoverRating(star)}
            onMouseLeave={() => clickable && setHoverRating(0)}
            style={{
              cursor: clickable ? 'pointer' : 'default',
              color: star <= (hoverRating || rating) ? '#ffc107' : '#e4e5e9',
              fontSize: size,
              marginRight: '0.25rem'
            }}
          >
            {star <= (hoverRating || rating) ? <FaStar /> : <FaRegStar />}
          </span>
        ))}
      </div>
    );
  };

  const getUserTypeLabel = (type) => {
    const userType = userTypes.find(ut => ut.value === type);
    return userType ? userType.label : type;
  };

  const getUserTypeIcon = (type) => {
    const userType = userTypes.find(ut => ut.value === type);
    return userType ? userType.icon : <FaUser />;
  };

  return (
    <div className="min-vh-100" style={{ backgroundColor: '#ffffffff' }}>
      <div className="bg-dark-subtle text-dark py-3 my-5">
        <div className="container">
          <img src={logo} alt="olewin academy" className='img-fluid mx-auto d-flex w-25 h-25'/>
          <div className="text-center">
            <FaCommentDots style={{ fontSize: '3rem' }} className="mb-3" />
            <h1 className="display-4 text-primary-emphasis fw-bold mb-3">Share Your Feedback</h1>
            <p className="lead">Help us improve Olewin Academy with your valuable feedback</p>
            <Link to="/google-reviews" className='btn btn-success text-white fw-bold rounded-5 border-1 px-5 py-3 m-3 '> <FaGooglePlus className=" text-white  " size={30} /> Share Your Feedback to Google Reviews </Link>
          </div>
        </div>
      </div>

      {showSuccess && (
        <div className="container mt-4">
          <div className="alert alert-success alert-dismissible fade show" role="alert">
            <FaCheckCircle className="me-2" />
            <strong>Thank you!</strong> Your feedback has been submitted successfully.
            <button type="button" className="btn-close" onClick={() => setShowSuccess(false)}></button>
          </div>
        </div>
      )}

      {showError && (
        <div className="container mt-4">
          <div className="alert alert-danger alert-dismissible fade show" role="alert">
            <FaExclamationTriangle className="me-2" />
            <strong>Error!</strong> {errorMessage}
            <button type="button" className="btn-close" onClick={() => setShowError(false)}></button>
          </div>
        </div>
      )}

      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-4 p-md-5">
                <h2 className="h3 mb-4 text-center">Submit Your Feedback</h2>
                
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      <FaUser className="me-2" />
                      Full Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder="Enter your name"
                      disabled={submitting}
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      <FaEnvelope className="me-2" />
                      Email Address <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="your.email@example.com"
                      disabled={submitting}
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      <FaBuilding className="me-2" />
                      I am a <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select"
                      name="userType"
                      value={formData.userType}
                      onChange={handleInputChange}
                      disabled={submitting}
                    >
                      <option value="">Select your role</option>
                      {userTypes.map(type => (
                        <option key={type.value} value={type.value}>{type.label}</option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      <FaGraduationCap className="me-2" />
                      Course/Interest Area
                    </label>
                    <select
                      className="form-select"
                      name="course"
                      value={formData.course}
                      onChange={handleInputChange}
                      disabled={submitting}
                    >
                      <option value="">Select a course (optional)</option>
                      {courses.map(course => (
                        <option key={course} value={course}>{course}</option>
                      ))}
                    </select>
                  </div>

                  <div className="col-12">
                    <label className="form-label fw-semibold">
                      <FaStar className="me-2" />
                      Overall Rating <span className="text-danger">*</span>
                    </label>
                    <div className="p-3 bg-light rounded text-center">
                      {renderStars(formData.rating, !submitting, '2rem')}
                      <p className="mt-2 mb-0 text-muted">
                        {formData.rating === 0 && 'Click to rate'}
                        {formData.rating === 1 && 'Poor'}
                        {formData.rating === 2 && 'Fair'}
                        {formData.rating === 3 && 'Good'}
                        {formData.rating === 4 && 'Very Good'}
                        {formData.rating === 5 && 'Excellent'}
                      </p>
                    </div>
                  </div>

                  <div className="col-12">
                    <label className="form-label fw-semibold">
                      <FaComment className="me-2" />
                      Your Feedback <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className="form-control"
                      name="comment"
                      value={formData.comment}
                      onChange={handleInputChange}
                      rows="5"
                      placeholder="Share your experience with Olewin Academy..."
                      disabled={submitting}
                    ></textarea>
                    <div className="form-text">Minimum 10 characters</div>
                  </div>

                  <div className="col-12">
                    <button 
                      type="button" 
                      className="btn btn-primary btn-lg w-100"
                      onClick={handleSubmit}
                      disabled={submitting}
                    >
                      {submitting ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Submitting...
                        </>
                      ) : (
                        <>
                          <FaPaperPlane className="me-2" />
                          Submit Feedback
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {feedbacks.length > 0 && (
        <div className="bg-white py-3">
          <div className="container">
            <div className="row text-center g-4">
              <div className="col-md-3 col-6">
                <div className="p-3">
                  <h3 className="display-4 text-primary mb-2">{feedbacks.length}</h3>
                  <p className="text-muted mb-0">Total Reviews</p>
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="p-3">
                  <h3 className="display-4 text-warning mb-2">{getAverageRating()}</h3>
                  <p className="text-muted mb-0">Average Rating</p>
                  {renderStars(Math.round(parseFloat(getAverageRating())))}
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="p-3">
                  <h3 className="display-4 text-success mb-2">
                    {feedbacks.filter(f => f.rating >= 4).length}
                  </h3>
                  <p className="text-muted mb-0">Happy Customers</p>
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="p-3">
                  <h3 className="display-4 text-info mb-2">
                    {new Set(feedbacks.map(f => f.course).filter(c => c && c !== 'Not specified')).size}
                  </h3>
                  <p className="text-muted mb-0">Courses Reviewed</p>
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-lg-8 mx-auto">
                <div className="card border-0 shadow-sm">
                  <div className="card-body">
                    <h4 className="h5 mb-4">Rating Distribution</h4>
                    {Object.entries(getRatingDistribution()).reverse().map(([rating, count]) => (
                      <div key={rating} className="mb-3">
                        <div className="d-flex align-items-center">
                          <span className="me-2" style={{ minWidth: '80px' }}>
                            {rating} <FaStar className="text-warning" />
                          </span>
                          <div className="progress flex-grow-1" style={{ height: '20px' }}>
                            <div
                              className="progress-bar bg-warning"
                              style={{ width: `${feedbacks.length > 0 ? (count / feedbacks.length) * 100 : 0}%` }}
                            >
                              {count > 0 && count}
                            </div>
                          </div>
                          <span className="ms-2 text-muted" style={{ minWidth: '60px', textAlign: 'right' }}>
                            {feedbacks.length > 0 ? Math.round((count / feedbacks.length) * 100) : 0}%
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div id="feedbacks-section" className="container py-5">
        <div className="text-center mb-5">
          <h2 className="display-5 fw-bold mb-3">What People Say About Us</h2>
          <p className="lead text-muted">Real feedback from our students, parents, and partners</p>
        </div>

        {feedbacks.length > 0 && (
          <div className="d-flex justify-content-center flex-wrap gap-2 mb-4">
            <button
              className={`btn ${filter === 'all' ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setFilter('all')}
            >
              <FaFilter className="me-2" />
              All ({feedbacks.length})
            </button>
            {userTypes.map(type => {
              const count = feedbacks.filter(f => f.userType === type.value).length;
              return count > 0 && (
                <button
                  key={type.value}
                  className={`btn ${filter === type.value ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => setFilter(type.value)}
                >
                  {type.icon} <span className="ms-2">{type.label} ({count})</span>
                </button>
              );
            })}
          </div>
        )}

        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3 text-muted">Loading feedbacks...</p>
          </div>
        ) : filteredFeedbacks.length === 0 ? (
          <div className="text-center py-5">
            <FaComment style={{ fontSize: '4rem', opacity: 0.2 }} />
            <h3 className="h5 mt-3 text-muted">
              {feedbacks.length === 0 ? 'No feedback yet. Be the first to share!' : 'No feedback found for this filter.'}
            </h3>
          </div>
        ) : (
          <div className="row g-4">
            {filteredFeedbacks.map((feedback) => (
              <div key={feedback.timestamp} className="col-lg-4 col-md-6">
                <div className="card border-0 shadow-sm h-100">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div className="d-flex align-items-center">
                        <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center" 
                             style={{ width: '50px', height: '50px', fontSize: '1.5rem' }}>
                          {getUserTypeIcon(feedback.userType)}
                        </div>
                        <div className="ms-3">
                          <h5 className="mb-0">{feedback.name}</h5>
                          <small className="text-muted">{getUserTypeLabel(feedback.userType)}</small>
                        </div>
                      </div>
                      {renderStars(feedback.rating, false, '1rem')}
                    </div>
                    
                    {feedback.course && feedback.course !== 'Not specified' && (
                      <div className="mb-2">
                        <span className="badge bg-light text-dark">
                          <FaGraduationCap className="me-1" />
                          {feedback.course}
                        </span>
                      </div>
                    )}
                    
                    <div className="position-relative">
                      <FaQuoteLeft className="text-primary opacity-25 position-absolute" 
                                   style={{ fontSize: '2rem', top: '-10px', left: '-5px' }} />
                      <p className="mb-3 mt-3 fst-italic" style={{ paddingLeft: '30px' }}>
                        {feedback.comment}
                      </p>
                    </div>
                     <FaQuoteRight className="text-primary opacity-25 position-absolute" 
                                   style={{ fontSize: '1.5rem', bottom: '15px', right: '25px' }} />
                    {/* <div className="text-end">
                      <small className="text-muted">{feedback.date}</small>
                    </div> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="bg-primary text-white py-5">
        <div className="container text-center">
          <h2 className="h3 mb-3">Haven't shared your experience yet?</h2>
          <p className="lead mb-4">Your feedback helps us serve you better</p>
          <button 
            className="btn btn-light btn-lg"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <FaPaperPlane className="me-2" />
            Share Your Feedback
          </button>
        </div>
      </div>

      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
        rel="stylesheet"
      />
    </div>
  );
};

export default FeedbackSystem;